
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/modal",
      function () {
        return require("private-next-pages/components/modal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/modal"])
      });
    }
  